import React from 'react';
import { Shield, Award, ThumbsUp, RefreshCw } from 'lucide-react';
export function TrustBadges() {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 my-10 border-y border-gray-200 py-8" data-id="element-70">
      <div className="flex flex-col items-center text-center gap-2" data-id="element-71">
        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-gray-700" data-id="element-72">
          <Shield size={24} data-id="element-73" />
        </div>
        <span className="text-xs font-bold uppercase tracking-wide text-gray-600" data-id="element-74">
          Secure Checkout
        </span>
      </div>
      <div className="flex flex-col items-center text-center gap-2" data-id="element-75">
        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-gray-700" data-id="element-76">
          <Award size={24} data-id="element-77" />
        </div>
        <span className="text-xs font-bold uppercase tracking-wide text-gray-600" data-id="element-78">
          Top Rated
        </span>
      </div>
      <div className="flex flex-col items-center text-center gap-2" data-id="element-79">
        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-gray-700" data-id="element-80">
          <ThumbsUp size={24} data-id="element-81" />
        </div>
        <span className="text-xs font-bold uppercase tracking-wide text-gray-600" data-id="element-82">
          Satisfaction Guarantee
        </span>
      </div>
      <div className="flex flex-col items-center text-center gap-2" data-id="element-83">
        <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-gray-700" data-id="element-84">
          <RefreshCw size={24} data-id="element-85" />
        </div>
        <span className="text-xs font-bold uppercase tracking-wide text-gray-600" data-id="element-86">
          Easy Returns
        </span>
      </div>
    </div>;
}